import { FC } from "react";
import { FooterContainer } from "./container";

export const Footer: FC = () => {
  return <FooterContainer />;
};
